import * as yup from 'yup';
import { ASSISTENZSYSTEME } from '@/features/Sparten/shared/types';

const assistenzSystemeSchema = yup
  .string()
  .default(ASSISTENZSYSTEME.NICHT_VORHANDEN)
  .oneOf([
    ASSISTENZSYSTEME.NACHGERUESTET,
    ASSISTENZSYSTEME.NICHT_VORHANDEN,
    ASSISTENZSYSTEME.SERIENMAESSIG,
  ]);

export const assistenzsysteme = yup.object({
  abstandsregeltempomat: assistenzSystemeSchema,
  antiblockiersystem: assistenzSystemeSchema,
  bremsassistent: assistenzSystemeSchema,
  elektronischeDiebstahlwarnanlage: assistenzSystemeSchema,
  elektronischeWegfahrsperre: assistenzSystemeSchema,
  elektronischesStabilitaetsprogramm: assistenzSystemeSchema,
  fahrzeugortungssystem: assistenzSystemeSchema,
  nachtsichtassistent: assistenzSystemeSchema,
  spurhalteassistent: assistenzSystemeSchema,
  spurwechselassistent: assistenzSystemeSchema,
  tagfahrlicht: assistenzSystemeSchema,
  unfalldatenschreiber: assistenzSystemeSchema,
});
